const o = ["#CD5FCF"], _ = [...o, "#CF0217"], t = [..._, "#4E02AC"], A = [..._, "#BF4E03", t[2]];
export {
  o as POI_8_TA1,
  _ as POI_8_TA2,
  t as POI_8_TA3,
  A as POI_8_TA4
};
//# sourceMappingURL=index.es5585.js.map
